import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import * as Yup from "yup";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import {
  editSociety,
  fetchSocietyList,
} from "src/actions/societyAction";

const useStyles = makeStyles(() => ({
  root: {},
}));

function SocietyEdit({ className, ...rest }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { state } = useLocation();

  return (
    <Formik
      enableReinitialize
      initialValues={{
        societyId: state?.societyId || "",
        societyName: state?.societyName || "",
        city: state?.city || "",
        area: state?.area || "",
        state: state?.state || "",
        pinCode: state?.pinCode || "",
      }}
      validationSchema={Yup.object().shape({
        societyName: Yup.string().required("Society Name is required"),
        city: Yup.string().required("City is required"),
        area: Yup.string().required("Area is required"),
        state: Yup.string().required("State is required"),
        pinCode: Yup.string().required("Pin Code is required"),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting }
      ) => {
        try {
          await dispatch(editSociety(values));

          enqueueSnackbar("Society Updated Successfully", {
            variant: "success",
          });

          dispatch(fetchSocietyList());

          navigate("/app/management/society");

        } catch (err) {

          setErrors({
            submit: err.message,
          });

          setStatus({
            success: false,
          });

          setSubmitting(false);

          enqueueSnackbar("Failed to Update Society", {
            variant: "error",
          });
        }
      }}
    >
      {({
        errors,
        touched,
        values,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
      }) => (
        <form
          onSubmit={handleSubmit}
          className={clsx(classes.root, className)}
          {...rest}
        >
          <h2 style={{ marginLeft: "1.5em" }}>
            Update Society
          </h2>

          <Card
            style={{
              width: "1150px",
              marginLeft: "2em",
              marginTop: "2em",
            }}
          >
            <CardHeader title="Update Society" />

            <Divider />

            <CardContent>
              <Grid container spacing={3}>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled
                    label="Society Id"
                    name="societyId"
                    value={values.societyId}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Society Name"
                    name="societyName"
                    value={values.societyName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.societyName &&
                      errors.societyName
                    )}
                    helperText={
                      touched.societyName &&
                      errors.societyName
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="Area"
                    name="area"
                    value={values.area}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.area && errors.area)}
                    helperText={touched.area && errors.area}
                />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="City"
                    name="city"
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.city &&
                      errors.city
                    )}
                    helperText={
                      touched.city &&
                      errors.city
                    }
                  />
                </Grid>


                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="State"
                    name="state"
                    value={values.state}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.state &&
                      errors.state
                    )}
                    helperText={
                      touched.state &&
                      errors.state
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Pin Code"
                    name="pinCode"
                    value={values.pinCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.pinCode &&
                      errors.pinCode
                    )}
                    helperText={
                      touched.pinCode &&
                      errors.pinCode
                    }
                  />
                </Grid>

              </Grid>
            </CardContent>
          </Card>

          {errors.submit && (
            <Box mt={3}>
              <FormHelperText error>
                {errors.submit}
              </FormHelperText>
            </Box>
          )}

          <Box mt={2}>
            <Button
              color="secondary"
              variant="contained"
              type="submit"
              disabled={isSubmitting}
              style={{
                marginBottom: "5em",
                marginLeft: "2em",
              }}
            >
              Update
            </Button>

            <Button
              color="secondary"
              variant="outlined"
              style={{
                marginBottom: "5em",
                marginLeft: "1em",
              }}
              onClick={() =>
                navigate("/app/management/society")
              }
            >
              Cancel
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
}

SocietyEdit.propTypes = {
  className: PropTypes.string,
};

export default SocietyEdit;